/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { EditorDocWithSearchMetadata } from '../models/EditorDocWithSearchMetadata';
import type { EmployeeWithSearchMetadata } from '../models/EmployeeWithSearchMetadata';
import type { InstantAnswerResponse } from '../models/InstantAnswerResponse';
import type { InstantAnswerSummaryResponse } from '../models/InstantAnswerSummaryResponse';
import type { KnowledgeSearchResult } from '../models/KnowledgeSearchResult';
import type { NewsPostWithSearchMetadata } from '../models/NewsPostWithSearchMetadata';
import type { PeopleSearchRankingMode } from '../models/PeopleSearchRankingMode';
import type { TeamWithSearchMetadata } from '../models/TeamWithSearchMetadata';
import type { WorkstreamSearchNavigationItemWithSearchMetadata } from '../models/WorkstreamSearchNavigationItemWithSearchMetadata';
import type { WorkstreamWithSearchMetadata } from '../models/WorkstreamWithSearchMetadata';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class SearchService {

    /**
     * Search Endpoint
     * @param name
     * @param filter
     * @param sParam
     * @param includeWorkstreamScopes
     * @param limit
     * @param skip
     * @param rankingMode
     * @returns any Successful Response
     * @throws ApiError
     */
    public static searchApiV1SearchGet(
        name: string,
        filter: string,
        sParam: boolean,
        includeWorkstreamScopes: boolean = false,
        limit?: number,
        skip?: number,
        rankingMode?: (PeopleSearchRankingMode | null),
    ): CancelablePromise<Array<(EmployeeWithSearchMetadata | WorkstreamWithSearchMetadata | TeamWithSearchMetadata | NewsPostWithSearchMetadata | EditorDocWithSearchMetadata | WorkstreamSearchNavigationItemWithSearchMetadata)>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/search',
            query: {
                'name': name,
                'filter': filter,
                's_param': sParam,
                'include_workstream_scopes': includeWorkstreamScopes,
                'limit': limit,
                'skip': skip,
                'ranking_mode': rankingMode,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Instant answer for a question-shaped search query
     * One answer card built without a model (see ``helpers.instant_answers``);
     * ``answer`` is null when nothing is confident.
     * @param q
     * @returns InstantAnswerResponse Successful Response
     * @throws ApiError
     */
    public static searchInstantAnswerApiV1SearchInstantAnswerGet(
        q: string,
    ): CancelablePromise<InstantAnswerResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/search/instant_answer',
            query: {
                'q': q,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * One-sentence answer from a knowledge instant answer's article
     * One fast model call over the card's article (see
     * ``helpers.instant_answer_summary``). Access to ``article_id`` is checked
     * again here; ``summary`` is null when it can't be read or the call fails.
     * @param q
     * @param articleId
     * @returns InstantAnswerSummaryResponse Successful Response
     * @throws ApiError
     */
    public static searchInstantAnswerSummaryApiV1SearchInstantAnswerSummaryGet(
        q: string,
        articleId: string,
    ): CancelablePromise<InstantAnswerSummaryResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/search/instant_answer/summary',
            query: {
                'q': q,
                'article_id': articleId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Knowledge articles and home links for a global-search query
     * Matching home-chip links, then the Knowledge articles the asker may read
     * (see ``helpers.knowledge_search``). Separate from ``/api/v1/search`` so
     * people results never wait on the embedding or ServiceNow.
     * @param q
     * @param limit
     * @returns KnowledgeSearchResult Successful Response
     * @throws ApiError
     */
    public static searchKnowledgeApiV1SearchKnowledgeGet(
        q: string,
        limit: number = 8,
    ): CancelablePromise<Array<KnowledgeSearchResult>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/search/knowledge',
            query: {
                'q': q,
                'limit': limit,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

}
